import {SystemPopupsManager, SystemPopupsManagerEvents, SystemPopupsView} from './index';
import {ModuleState} from '@gongxigames/framework/slot/fragments/module/ModuleState';

export class SystemPopupsModuleShowingState extends ModuleState<SystemPopupsView, SystemPopupsManager, SystemPopupsManagerEvents> {
    public onEnterState(): void {
        this.checkHasPopupAndShowOrLeaveState();
        this.module.disableUI();
    }

    public onLeaveState(): void {
        this.module.enableUI();
    }

    protected setupEvents(): void {
        this.setEventHandler('SystemPopupsManager.POPUP_HID', this.checkHasPopupAndShowOrLeaveState.bind(this));
        this.setEventHandler('General.Popups.Add', this.checkPopupsForSwap.bind(this));
    }

    protected checkPopupsForSwap(popup: any): void {
        if (this.module.isHigherPriorityVisiblePopup(popup)) {
            this.module.hideNotPrioritizedPopup(popup);
        } else {
            this.module.swapVisiblePopupToNextPopup();
        }
    }

    protected checkHasPopupAndShowOrLeaveState(): void {
        if (this.module.hasPopups()) {
            this.module.showNextPopup();
        } else {
            this.module.allPopupsHidden();
        }
    }
}
